<template>
    <div v-show="!loading" v-title class="box">
        <div class="radio-content">
            <div class="radio-title">
                <!-- This is litle This is litleThis is litle This is litle -->
                {{curPlayAudio.audioName}}
            </div>
            <div class="radio-tape">
                <img
                    :class="['tape-img', btnState=='pause'?'active':'paused']"
                    :src="albumInfo.albumCover"
                >
                <img class="bg" src="https://g.gsxcdn.com/2700639417_qztjs54z.png" alt="" srcset="">
            </div>
            <div class="radio-play">
                <div id="pro" class="progress">
                    <span class="left" :style="leftStyle"></span>
                    <img
                        draggable="true"
                        class="circle"
                        src="https://g.gsxcdn.com/2700716519_9ygoaxc5.png"
                        @touchstart="circletouchStart"
                        @touchmove="circletouchMove"
                        @touchend="circletouchEnd"
                    >
                </div>
                <div class="num-box">
                    <span class="left-num">{{progress}}</span>
                    <span class="right-num">{{duration}}</span>
                </div>
            </div>
            <audio
                id="radio-audio"
                preload="auto"
                :src="curPlayAudio.audioUrl"
                style="display: none;"
                @canplaythrough="audioCanplaythrough"
                @timeupdate="audioTimeupdate"
                @ended="audioEnd"
            ></audio>
            <div :class="['radio-btn', single ? 'hor-center':'']">
                <!-- order顺序；random随机；only单曲 -->
                <img
                    class="play-way"
                    :src="playWayArr[playIndex].img"
                    @click="chooseMood"
                >
                <img
                    class="left-btn"
                    src="https://g.gsxcdn.com/2700591976_ihwgljn9.png"
                    @click="songHandle('pre')"
                >
                <img
                    class="play-btn"
                    :src="btnState === 'pause' ? 'https://i.gsxcdn.com/2700712754_ie7wnogc.png' : 'https://i.gsxcdn.com/2700714896_fwgd76qe.png'"
                    @click="playHandle"
                >
                <img
                    class="right-btn"
                    src="https://g.gsxcdn.com/2700594036_kpx4kfk6.png"
                    @click="songHandle('next')"
                >
                <img
                    class="list-btn"
                    src="https://g.gsxcdn.com/2700596319_5o06uwry.png"
                    @click="showRadioList"
                >
            </div>
        </div>
        <div v-show="showList" class="list-cover" @click="hideRadioList"></div>
        <div :class="['list-container', showList ? 'listUp' : '']">
            <div class="list-top">
                <div class="list-title">
                    当前播放
                </div>
                <img class="list-close" src="https://g.gsxcdn.com/2700727356_mr5872sc.png" @click="hideRadioList">
            </div>
            <div class="scroll-box" ref="audiobox" @scroll="handleScroll">
                <div
                    v-for="(item, index) in radioData"
                    :key="index"
                    :ref="'audio' + index"
                    class="song-box"
                    @click="changeSong(index)"
                >
                    <img v-if="curPlayIndex === index" class="song-note" src="https://i.gsxcdn.com/2700611800_8j5v8lqm.png">
                    <div v-else class="song-index">{{index + 1}}</div>
                    <div :class="['song-name', curPlayIndex === index ? 'cur-name' : '']">
                        {{item.audioName}}
                    </div>
                </div>
                <div class="tips">
                    没有更多内容啦～
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {audioList} from '@/api/api';
import {
    getRandom,
    isIPAD
} from '@/utils/utils';

let proW = 0;
let curW = 0;
export default {
    components: {
    },
    data() {
        return {
            albumInfo: {},
            loading: true,

            startPos: {},
            isScrolling: 0,
            endPos: {},
            // 当前播放进度
            progress: '00:00',
            // 音频总进度
            duration: '10:00',
            leftStyle: {width: '0%'},
            draging: false,

            radioData: [],
            single: false,
            curPlayIndex: 0,
            curPlayAudio: {},
            playWayArr: [
                {
                    way: 'order',
                    img: 'https://i.gsxcdn.com/2700708676_0dz2iqfg.png',
                },
                // {
                //     way: 'random',
                //     img: 'https://i.gsxcdn.com/2700710912_slfrjzj3.png',
                // },
                {
                    way: 'only',
                    img: 'https://i.gsxcdn.com/2700710000_716ii5hz.png',
                }
            ],
            playIndex: 0,
            btnState: 'play',
            showList: false,
            endIndex: 0,
        };
    },
    computed: {
        visibleData() {
            return this.radioData.slice(0, this.endIndex);
        },
    },
    created() {
        let width = screen.width;
        let height = screen.height;

        if (height / width <= 4 / 3) {
            document.documentElement.style.fontSize = '52px';
        }
    },
    mounted() {
        this.oAudio = document.querySelector('#radio-audio');
        const {type, level, id} = this.$route.query;
        this.loading = false;
        this.audioList();
    },
    methods: {
        async audioList() {
            const {type, level, id} = this.$route.query;
            const res = await audioList({
                audioParam: id,
                type,
                level
            });
            if (res.code === '0') {
                const {albumInfo, list} = res.data;
                this.albumInfo = albumInfo;
                this.radioData = list;
                this.single = this.radioData.length === 1;
                list && list.forEach((item, index) => {
                    if (item?.audioParam === id) {
                        this.curPlayIndex = index;
                    }
                });
                this.curPlayAudio = this.radioData[this.curPlayIndex];
            }
            else {
                this.$toast(res.msg);
            }
        },

        // 手动修改音频播放进度
        circletouchStart(e) {
            if (this.oAudio.paused) {
                return;
            }
            this.draging = true;
            // touches数组对象获得屏幕上所有的touch，取第一个touch
            const touch = e.targetTouches[0];
            proW = document.querySelector('#pro').clientWidth;
            // 取第一个touch的坐标值
            this.startPos = {x: touch.pageX, y: touch.pageY};
            curW = Number(this.leftStyle.width.replace('%', ''));
        },
        circletouchMove(e) {
            // 当屏幕有多个touch或者页面被缩放过，就不执行move操作
            if (e.targetTouches.length > 1 || e.scale && e.scale !== 1 || this.oAudio.paused) {
                return;
            }
            const touch = e.targetTouches[0];
            this.endPos = {x: touch.pageX - this.startPos.x, y: touch.pageY - this.startPos.y};
            // isScrolling为1时，表示纵向滑动，0为横向滑动
            this.isScrolling = Math.abs(this.endPos.x) < Math.abs(this.endPos.y) ? 1 : 0;
            if (this.isScrolling === 0) {
                // 阻止触摸事件的默认行为，即阻止滚屏
                e.preventDefault();
                const w = curW + Number((this.endPos.x / proW * 100).toFixed(2));
                this.leftStyle.width = `${w}%`;
                const pro = w * this.oAudio.duration / 100;
                this.progress = this.timeFormat(pro);
            }
        },
        circletouchEnd(e) {
            if (this.oAudio.paused) {
                return;
            }
            this.draging = false;
            this.isScrolling = Math.abs(this.endPos.x) < Math.abs(this.endPos.y) ? 1 : 0;
            // 当为水平滚动时
            if (this.isScrolling === 0) {
                this.oAudio.currentTime = Number(this.leftStyle.width.replace('%', ''))
                    * this.oAudio.duration / 100;
                this.progress = this.timeFormat(this.oAudio.currentTime);
            }
        },
        // 手动修改音频播放进度

        // 浏览器预测已经可以在不暂停的前提下将媒体播放到结束。
        audioCanplaythrough(e) {
            this.duration = this.timeFormat(this.oAudio.duration);
        },
        // 音频播放位置发生变化【音频正常播放时】
        audioTimeupdate(e) {

            /**
             * 更新当前的播放进度值，progress
             * 更新进度条的值，leftStyle.width
             */
            if (!this.draging) {
                this.progress = this.timeFormat(this.oAudio.currentTime);
                this.leftStyle.width = this.percentFormat(this.oAudio.currentTime / this.oAudio.duration);
            }
        },
        // 音频播放完成
        audioEnd(e) {
            /**
             * 1、重置进度条的位置，leftStyle.width = 0；更新当前的播放进度值，progress
             * 2、判断当前播放模式，决定下一首播放什么
             * 3、重置播放按钮的状态，btnState
             * 4、设置curPlayAudio的值
             * 5、重新计算下一首的音频时长，赋值duration
             * 6、播放下一首，修改播放按钮状态
             */
            this.progress = '00:00';
            this.leftStyle.width = '0%';
            if (this.playWayArr[this.playIndex].way === 'order') {
                this.curPlayIndex = this.curPlayIndex === this.radioData.length - 1 ? 0 : ++this.curPlayIndex;
            }
            // else if (this.playWayArr[this.playIndex].way === 'random') {
            //     this.curPlayIndex = getRandom(0, this.radioData.length - 1);
            // }
            this.curPlayAudio = this.radioData[this.curPlayIndex];
            this.$nextTick(() => {
                this.playHandle();
            });
        },
        // 切换播放模式
        chooseMood() {

            /**
             * 播放模式切换不影响当前的播放状态，更新页面上的按钮状态和对应值playIndex
             */
            if (this.playIndex === this.playWayArr.length - 1) {
                this.playIndex = 0;
            }
            else {
                this.playIndex += 1;
            }
        },
        // 上一首下一首切换
        songHandle(way) {

            /**
             * 1、重置进度条的位置，leftStyle.width = 0；更新当前的播放进度值，progress
             * 2、判断当前播放模式，决定下一首播放什么
             * 3、设置下一首音频的src
             * 4、重新计算下一首的音频时长，赋值duration
             * 5、播放，修改播放按钮状态
             */
            if (way === 'pre') {
                // 切到上一首
                this.curPlayIndex = this.curPlayIndex === 0 ? this.radioData.length - 1 : --this.curPlayIndex;
            }
            else {
                // 切到下一首
                this.curPlayIndex = this.curPlayIndex === this.radioData.length - 1 ? 0 : ++this.curPlayIndex;
            }
            this.curPlayAudio = this.radioData[this.curPlayIndex];
            this.$nextTick(() => {
                this.playHandle();
            });
        },
        // 播放暂停切换
        playHandle() {
            if (this.oAudio.paused) {
                this.audioPlay(() => {
                    this.btnState = 'pause';
                    this.duration = this.timeFormat(this.oAudio.duration);
                    this.oAudio.play();
                });
            }
            else {
                this.btnState = 'play';
                this.oAudio.pause();
            }
        },

        showRadioList() {
            this.showList = true;
            // todo: 定位到当前播放的音频
            const nodes = this.$refs[`audio${this.curPlayIndex}`];
            const node = Array.isArray(nodes) ? nodes[0] : nodes;
            this.$refs.audiobox.scrollTo({
                top: node.offsetTop - 100,
                behavior: 'smooth'
            });
        },
        hideRadioList() {
            this.showList = false;
        },
        handleScroll(event) {
            if (this.endIndex === this.radioData.length) {
                return;
            }
            const el = event.target;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
                if (this.endIndex + 10 < this.radioData.length) {
                    this.endIndex += 10;
                }
                else {
                    this.endIndex = this.radioData.length;
                }
            }
        },
        changeSong(index) {
            this.curPlayIndex = index;
            this.curPlayAudio = this.radioData[this.curPlayIndex];
            this.$nextTick(() => {
                this.playHandle();
            });
        },

        /**
         * 判断音频是否能够播放
         *
         */
        audioPlay(fn) {
            const playPromise = this.oAudio.play();
            if (playPromise) {
                playPromise.then(() => {
                    fn();
                }).catch(() => {
                    console.log('error');
                });
            }
        },

        // 百分比格式转换
        percentFormat(percent) {
            return `${(percent * 100).toFixed(2)}%`;
        },
        // 时间转换
        timeFormat(time) {
            // this.oAudio.duration单位为秒
            const tempMin = parseInt(time / 60, 10);
            const tempSec = parseInt(time % 60, 10);
            const curMin = tempMin < 10 ? (`0${tempMin}`) : tempMin;
            const curSec = tempSec < 10 ? (`0${tempSec}`) : tempSec;
            return `${curMin}:${curSec}`;
        },
    }
};
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.box {
    width: 100vw;
    min-height: 100vh;
    overflow-x: scroll;

    .radio-content {
        width: 100vw;
        height: 100vh;
        overflow: scroll;
        background: url(https://i.gsxcdn.com/2700621333_lb41ig59.png) 0 0 no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .radio-title {
            max-width: 7.44rem;
            margin: 2.32rem 0 .29rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: .51rem;
            color: #FFFFFF;
            line-height: .61rem;
            text-align: justify;
            font-style: normal;
        }

        .radio-tape {
            width: 8.35rem;
            height: 8.35rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .tape-img {
                position: absolute;
                width: 7.81rem;
                height: 7.81rem;
                border-radius: 50%;
                animation: turn 5s linear infinite;
            }

            .bg {
                width: 8.35rem;
                height: 8.35rem;
                position: absolute;
                z-index: 1;
            }

            .active {
                animation-play-state: running;
            }

            .paused {
                animation-play-state: paused;
            }
        }

        .radio-play {
            margin: 2.83rem 0 .48rem;
            display: flex;
            flex-direction: column;

            .progress {
                display: flex;
                align-items: center;
                font-size: 0;
                width: 9.15rem;
                height: .13rem;
                background-color: rgba(255, 255, 255, .4);
                border-radius: .03rem;

                .left {
                    height: 100%;
                    display: inline-block;
                    background: #FFBA00;
                }

                .circle {
                    width: .53rem;
                    height: .53rem;
                    margin-left: -.1rem;
                }
            }

            .num-box {
                margin-top: .15rem;
                display: flex;
                justify-content: space-between;

                .left-num, .right-num {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: .32rem;
                    color: #FFFFFF;
                    line-height: .43rem;
                    text-align: left;
                    font-style: normal;
                }
            }
        }

        .hor-center {
            justify-content: center;
        }

        .radio-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 2rem;

            .play-way {
                width: .85rem;
                height: .85rem;
                margin-right: 1.52rem;
            }

            .left-btn, .right-btn {
                width: .85rem;
                height: .85rem;
            }

            .play-btn {
                width: 1.41rem;
                height: 1.41rem;
                margin: 0 .64rem;
            }

            .list-btn {
                width: .85rem;
                height: .85rem;
                margin-left: 1.52rem;
            }
        }
    }

    @keyframes turn {
        0%{-webkit-transform:rotate(0deg);}
        25%{-webkit-transform:rotate(90deg);}
        50%{-webkit-transform:rotate(180deg);}
        75%{-webkit-transform:rotate(270deg);}
        100%{-webkit-transform:rotate(360deg);}
    }
    @media only screen and (min-device-height : 813px) and (max-device-height : 1080px){
        .radio-title {
            margin-bottom: 2rem!important;
        }
    }

    .list-cover {
        z-index: 2;
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .75);
    }

    .list-container {
        z-index: 3;
        position: fixed;
        width: 100%;
        height: 64%;
        bottom: 0;
        background: #fff;
        border-radius: .32rem .32rem 0 0;
        display: flex;
        flex-direction: column;
        transform: translateY(100%);
        transition: transform .25s linear;
        padding-bottom: 1rem;

        .list-top {
            margin: .56rem 0;
            padding: 0 .05rem 0 .43rem;
            width: 100%;
            height: 1.71rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;

            .list-title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: .56rem;
                color: #0B0B0B;
            }

            .list-close {
                width: 1.17rem;
                height: 1.17rem;
            }
        }

        .scroll-box {
            width: 100%;
            overflow: scroll;
        }
    }

    .listUp {
        transform: translateY(0);
    }

    .song-box {
        display: flex;
        align-items: center;
        padding-left: .43rem;
        margin-bottom: .85rem;

        .song-note {
            width: .43rem;
            height: .4rem;
        }

        .song-index {
            width: .43rem;
            height: .4rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 600;
            font-size: .4rem;
            color: #6A6A6A;
        }

        .song-name {
            margin-left: .51rem;
            font-weight: 600;
            font-size: .4rem;
            color: #333333;
            line-height: .51rem;
            max-width: 85%;
            word-wrap: break-word;
        }

        .cur-name {
            color: #FC980F;
        }
    }

    .tips {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: .32rem;
        color: #AEAEAE;
        text-align: center;
    }
}
</style>
